import axios from "axios";

const get = ({ id }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`/campaignV2/customer/instantLuckyDraw/participantDetail?id=${id}`)
      .then((response) => resolve(response.data))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

const getParticipantDetail = {
  get
};

export default getParticipantDetail;
